import React, { memo } from "react";
import { Link } from "react-router-dom";

function CompletedActivityCard({
  heading,
  label,
  meta = "",
  secondaryMeta = "",
  icon = "assignment_turned_in",
  details = null,
  trailing = null,
  to = null,
}) {
  const hasDetails = React.Children.count(details) > 0;
  const hasMeta = Boolean(meta || secondaryMeta);
  // `icon` may be a Material Symbols name (string) or an already-rendered icon
  // element (e.g. a recording-mode SVG) so feeds can reuse the mode-button
  // icons. Element icons are sized/coloured to match the Material Symbol slot.
  const iconNode =
    typeof icon === "string" ? (
      <span
        className="material-symbols-outlined text-[22px] leading-none text-primary"
        aria-hidden="true"
      >
        {icon}
      </span>
    ) : (
      <span
        className="flex h-[22px] w-[22px] shrink-0 items-center justify-center text-primary [&_svg]:h-[22px] [&_svg]:w-auto [&_svg]:fill-current [&_svg]:stroke-current"
        aria-hidden="true"
      >
        {icon}
      </span>
    );

  const content = (
    <>
      {iconNode}
      <span
        className={`flex min-w-0 flex-1 ${
          hasDetails
            ? "flex-col items-start gap-2"
            : "items-baseline justify-between gap-3"
        }`}
      >
        <span className="flex w-full min-w-0 items-baseline justify-between gap-3">
          <span className="truncate text-sm font-semibold text-typography">
            {label}
          </span>
          {hasMeta ? (
            <span className="shrink-0 flex flex-row gap-1 items-end text-right leading-tight">
              {secondaryMeta ? (
                <span className="muted-text text-[11px]">{secondaryMeta}</span>
              ) : null}{" "}
              {meta ? <span className="muted-text text-xs">{meta}</span> : null}
            </span>
          ) : null}
        </span>
        {hasDetails ? (
          <span className="flex w-full flex-wrap items-center gap-1.5">
            {details}
          </span>
        ) : null}
      </span>
      {/* Sits outside the label/meta column so it stays hard right whatever
          the label does. */}
      {trailing ? <span className="shrink-0">{trailing}</span> : null}
    </>
  );
  const cardClassName = `w-full rounded-2xl bg-card px-3 py-3 shadow flex ${
    hasDetails ? "items-start" : "items-center"
  } gap-3 text-left`;

  return (
    <article className={`w-full flex flex-col${heading ? " gap-2" : ""}`}>
      {heading ? (
        <h3 className="text-lg font-bold text-typography">{heading}</h3>
      ) : null}
      {to ? (
        <Link to={to} className={cardClassName}>
          {content}
        </Link>
      ) : (
        <div className={cardClassName}>{content}</div>
      )}
    </article>
  );
}

export default memo(CompletedActivityCard);
